import { combineReducers } from 'redux'
import _ from 'lodash'

import * as arAgingSummary from './arAgingSummary'
import * as arAgingReport from './arAgingReport'
import * as residentBills from './residentBills'
import * as arAgingExportsList from './arAgingExportsList'

const slices = {
  arAgingSummary,
  arAgingReport,
  residentBills,
  arAgingExportsList
}

const arAgingTypes = _.mapValues(slices, (s) => s.slice.types)
const arAgingActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const arAgingSagas = _(slices).values().map('slice.sagas').flatten().value()
const arAgingSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { arAgingTypes, arAgingActions, arAgingSagas, arAgingSelectors }

export default combineReducers(reducers)
